'use client'

import { Combobox, ComboboxInput, ComboboxOption, ComboboxOptions } from '@headlessui/react'
import _ from 'lodash'
import { type ForwardedRef, forwardRef, useState } from 'react'
import { twMerge } from 'tailwind-merge'

type Props = {
  name: string
  option: number[]
  value?: string
  className?: string
  onChange: (val: string) => void
  inputMode?: 'text' | 'numeric' | 'tel' | 'email' | 'url'
} & React.ComponentPropsWithoutRef<'input'>

export const AutoComplete = forwardRef<HTMLInputElement, Props>((props: Props, ref: ForwardedRef<HTMLInputElement>) => {
  const { name, option, value, onChange, className, inputMode, ...rest } = props
  const [query, setQuery] = useState('')

  const filterd =
    query === ''
      ? option
      : _.filter(option, (d) => {
          return _.startsWith(d.toString(), query.toString())
        })

  return (
    <Combobox as='div' value={value} onChange={(val) => onChange(_.toString(val))} className={className} onClose={() => setQuery('')}>
      <div className={twMerge('relative mt-1 text-sm')}>
        <ComboboxInput
          name={name}
          as='input'
          className='form-listbox'
          onChange={(e) => setQuery(e.target.value)}
          ref={ref}
          autoComplete='off'
          onFocus={(e) => e.target.select()}
          type={inputMode}
          inputMode={inputMode}
          aria-label={rest['aria-label'] || name}
          {...rest}
        />
        <ComboboxOptions transition className='form-options'>
          {_.map(filterd || [], (d, idx) => {
            return (
              <ComboboxOption key={idx} value={d} className='form-option'>
                <span className='block truncate group-data-selected:font-semibold'>{d.toString()}</span>
              </ComboboxOption>
            )
          })}
        </ComboboxOptions>
      </div>
    </Combobox>
  )
})
